export const guideState = {
    unPrintedGuide:  'No impresa'
}